import React from 'react'
import injectSheet from 'react-jss'

import styles from './contribution-modal.styles.js'
import Button from 'pobble-components/dist/button'
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter
} from 'pobble-components/dist/modal'
import TextArea from 'pobble-components/dist/form-elements/form-text-area'
import Label from 'pobble-components/dist/form-elements/form-label'
import { Formik } from 'formik'
import ArrowIcon from 'react-icons/lib/fa/caret-right'

const ContributionModal = ({
  classes,
  id,
  onSubmit,
  isOpen,
  onClose,
  isConcluded
}) => (
  <Modal isOpen={isOpen}>
    <ModalHeader>Add contribution</ModalHeader>
    <Formik
      initialValues={{
        contribution: ''
      }}
      onSubmit={({ contribution }) => {
        onSubmit(id, contribution)
        onClose()
      }}>
      {props => {
        const { handleSubmit, handleChange, values, isValid } = props
        return (
          <form onSubmit={handleSubmit}>
            <ModalContent legacy>
              <Label htmlFor={'contribution'}>
                Please type your message below
              </Label>
              <TextArea
                id="contribution"
                name="contribution"
                value={values.contribution}
                onChange={handleChange}
                placeholder={'Eg. This pupil is working as expected.'}
              />
            </ModalContent>
            <ModalFooter className={classes.footer}>
              <Button simple tall action={onClose}>
                Cancel
              </Button>
              <Button type="submit" tall disabled={!isValid}>
                {`${
                  !isConcluded
                    ? 'Submit contribution'
                    : 'Reopen discussion and submit contribution'
                }`}{' '}
                <ArrowIcon />
              </Button>
            </ModalFooter>
          </form>
        )
      }}
    </Formik>
  </Modal>
)

export default injectSheet(styles)(ContributionModal)
